import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../AuthContext";

export default function RequireAdmin({ children }) {
    const { token, roles, hasRole } = useContext(AuthContext);
    const roleList = Array.isArray(roles) ? roles : roles ? [roles] : [];
    const isAdmin = (typeof hasRole === "function" && hasRole("ADMIN")) || roleList.includes("ADMIN");
    if (!token || !isAdmin) {
        return <Navigate to="/" replace />;
    }
    return children;
}
